// Full-screen image viewer. Extracted verbatim from the product detail modal
// so the same gallery UX is shared; `.broken` is the added missing/failed
// image fallback.
.lightbox {
  align-items: center;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
  // Above the shared Modal overlay (z-index: 2000) so the lightbox sits on top
  // of the modal/drawer it opens from.
  z-index: 2100;
}

.backdrop {
  background: transparent;
  border: none;
  cursor: default;
  inset: 0;
  padding: 0;
  position: absolute;
  z-index: 1;
}

.stage {
  height: 80vh;
  max-height: 90vh;
  max-width: 90vw;
  position: relative;
  width: 80vw;
  z-index: 2;

  @media (min-width: 1024px) {
    height: 60vh;
    width: 60vw;
  }
}

.count {
  background: rgba(0, 0, 0, 0.4);
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  left: 50%;
  padding: 4px 8px;
  position: absolute;
  top: 8px;
  transform: translateX(-50%);
  z-index: 2;
}

.img {
  border-radius: 12px;
  height: 100%;
  object-fit: contain;
  width: 100%;
}

.broken {
  align-items: center;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.nav-btn {
  align-items: center;
  background: rgba(255, 255, 255, 0.6);
  border: none;
  border-radius: 999px;
  color: #000;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 8px;
  position: absolute;
  z-index: 2;

  &:hover {
    background: rgba(255, 255, 255, 0.85);
  }
}

.nav-prev {
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.nav-next {
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.nav-close {
  right: 8px;
  top: 8px;
}
